import AsyncView from '@pixelunion/shopify-asyncview';
import rimg from '@pixelunion/rimg-shopify';
import Flickity from 'flickity';
import EventHandler from '@pixelunion/events';

import ProductThumbnail from '../components/ProductThumbnail';

export default class ProductRecommendations {
  constructor(section) {
    this.sectionId = section.id;
    this.el = section.el;
    const {
      customCollectionEnabled,
      layout,
      productId,
      productsPerRow,
      limit,
      sectionEnabled,
      showSecondaryMediaOnHover,
    } = section.data;

    const recommendedProductsUrl = window.PXUTheme.routes.product_recommendations;

    const requestUrl = `${recommendedProductsUrl}?section_id=${this.sectionId}&limit=${limit}&product_id=${productId}`;

    if (!sectionEnabled) { return; }

    this.events = new EventHandler();

    const thumbnailSettings = {
      showSecondaryMediaOnHover,
    };

    const initializeThumbnails = () => {
      this.productList = this.container.querySelectorAll('[data-product-thumbnail]');
      this.productThumbnails = [];

      this.productList.forEach(product => {
        this.productThumbnails.push(new ProductThumbnail(product, thumbnailSettings));
      });
    };

    const enableSlider = el => {
      this.slider = el.querySelector('[data-product-slider]');
      this.toggleSlider = limit > productsPerRow;
      if (this.slider && layout === 'slider') {
        // Enable slider
        this.Flickity = new Flickity(this.slider, {
          wrapAround: true,
          pageDots: false,
          cellAlign: 'left',
          prevNextButtons: this.toggleSlider,
          draggable: this.toggleSlider,
        });

        if (this.toggleSlider === false) {
          this.isDraggable();
          this.events.register(window, 'resize', () => {
            this.isDraggable();
          });
        }

        // Ensures Flickity is not collapsed when loaded
        setTimeout(() => {
          this.Flickity.resize();
        }, 500);

        this.events.register(window, 'load', () => {
          this.Flickity.resize();
        });
      }
    };

    this.container = this.el;
    this.container.classList.remove('product-recommendations--hidden');

    // If using custom collection
    if (customCollectionEnabled) {
      rimg.watch(this.container);
      initializeThumbnails();
      enableSlider(this.container);
      return;
    }

    AsyncView.load(
      requestUrl,
      { view: '' },
    ).then(({ html }) => {
      this.container.innerHTML = html;

      rimg.watch(this.container);
      initializeThumbnails();
      enableSlider(this.container);

      // Initialize Shopify payment buttons
      if (Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }
    });
  }

  isDraggable() {
    if (this.viewportIsMobile()) {
      this.Flickity.options.draggable = true;
      this.Flickity.updateDraggable();
    } else {
      this.Flickity.options.draggable = false;
      this.Flickity.updateDraggable();
    }
  }

  viewportIsMobile() {
    return window.innerWidth < 768;
  }

  onSectionUnload() {
    if (this.Flickity) {
      this.Flickity.destroy();
    }

    if (this.productThumbnails) {
      this.productThumbnails.forEach(product => product.unload());
    }

    this.events.unregisterAll();
  }
}
